var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWww(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    transform: "translate(-1173 -4356)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1173 4356)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1173 -4355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.98,39.739A16.76,16.76,0,1,0,6.22,22.98,16.76,16.76,0,0,0,22.98,39.739Zm0-31.422A14.662,14.662,0,1,1,8.317,22.98,14.662,14.662,0,0,1,22.98,8.317Z",
    transform: "translate(-6.22 -6.22)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.567,23.124l1.223,4.56h1.3l1.481-6.1h-1.24L17.4,25.846,16.326,21.58H14.862l-1.116,4.194-.919-4.194H11.56l1.464,6.1h1.339Z",
    transform: "translate(-6.794 -7.872)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.383,27.684l1.2-4.56,1.223,4.56h1.3l1.49-6.1h-1.24l-.937,4.266L25.356,21.58H23.883l-1.116,4.194-.919-4.194H20.59l1.455,6.1Z",
    transform: "translate(-7.766 -7.872)",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4,27.684l1.214-4.56,1.214,4.56h1.3l1.49-6.1h-1.24l-.937,4.266L34.376,21.58H32.9l-1.116,4.194-.919-4.194H29.61l1.455,6.1Z",
    transform: "translate(-8.736 -7.872)",
    fill: "#e8eaea"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWww);
export default __webpack_public_path__ + "static/media/www.981a92bb36afbcf93761a4b6309cffae.svg";
export { ForwardRef as ReactComponent };